import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "assests/images";
import { PatientForm } from "components";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";
import { IValidationParms } from "utility/interfaces/common/validation-parms";
import { IPatientDetails } from "utility/interfaces/create-request/create-request-details";
import { patientFormSchema } from "utility/validations";

const PatientRequest: React.FC = () => {
  // Page level variables
  const navigate = useNavigate();

  // state variables
  const [patientDetails, setPatientDetails] = useState<IPatientDetails>({
    symptoms: "",
    firstName: "",
    lastName: "",
    birthDate: "",
    email: "",
    phoneNumber: "",
    isPatientSMSOpted: false,
    radioClientPhoneType: "M",
    password: "",
    confirmPassword: "",
    street: "",
    city: "",
    state: "",
    zipCode: "",
    room: "",
    document: "",
    documentName: "",
    clientRegionId: 0,
  });

  // Handle events and functions
  const handleOnBackButtonClick = () => {
    navigate(AppRoutings.CreateRequest);
  };

  const onChangePatientDetails = (name: string, value: any) => {
    setPatientDetails({ ...patientDetails, [name]: value });
  };

  // Yup resolver and validation
  const {
    register: patientFormRegister,
    handleSubmit: patientFormHandleSubmit,
    formState: { errors: patientFormErrors },
    reset: patientFormReset,
    clearErrors: patientFormClearErrors,
    setValue: patientFormSetValue,
    getValues: patientFormGetvalues,
    setError: patientFormSetError,
  } = useForm({
    reValidateMode: "onSubmit",
    resolver: yupResolver(patientFormSchema),
  });
  const patientFormValidation: IValidationParms = {
    register: patientFormRegister,
    handleSubmit: patientFormHandleSubmit,
    errors: patientFormErrors,
    reset: patientFormReset,
    clearErrors: patientFormClearErrors,
    setValue: patientFormSetValue,
    getValues: patientFormGetvalues,
    setError: patientFormSetError,
  };

  // use effects
  useEffect(() => {
    Object.entries(patientDetails).forEach((child) => {
      patientFormValidation.setValue(child[0] as any, child[1] || "");
    });
  }, [patientDetails]);

  return (
    <>
      <main className="main-content">
        <div
          className="overlay"
          onClick={(e) => document.body.classList.toggle("sidebar-toggle")}
        ></div>

        <Box className="request-container-box">
          <div className="request-header">
            <div></div>
            <Button onClick={handleOnBackButtonClick} variant="outlined">
              <img src={ArrowBack} alt="arrow" />
              Back
            </Button>
          </div>

          <PatientForm
            handleOnBackButtonClick={handleOnBackButtonClick}
            validationParams={patientFormValidation}
            patientDetails={patientDetails}
            onChangePatientDetails={onChangePatientDetails}
          />
        </Box>
      </main>
    </>
  );
};

export default PatientRequest;
